import React from 'react';
import { Text } from './Notification.styled';

export const Notification = ({ message }) => {
  return <Text>{message}</Text>;
};
